export default __webpack_public_path__ + "static/media/FELES_Superv_white.d1f15054.svg";